import React, { useEffect, useState } from 'react';
import { Box, Button, Skeleton, Stack, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import styles from './styles';

const HandsetColorSelector = ({ colors, loadingHandset, selected, selectVariant }) => {
  const [selectedColor, setSelectedColor] = useState();

  const handleColorChange = value => {
    selectVariant('color', value);
    setSelectedColor(value);
  };

  useEffect(() => {
    setSelectedColor(selected.color);
  }, [selected.color]);

  const theme = useTheme();
  return !loadingHandset ? (
    <Stack>
      <Typography variant='subtitle2' sx={styles(theme).colorTitle}>
        Colour:
        <Typography variant='body2' sx={styles(theme).storageValue}>
          &nbsp; {selectedColor}
        </Typography>
      </Typography>
      <Stack direction='row' spacing={2}>
        {colors?.map((color, i) => (
          <Stack key={i}>
            <Box
              id={`${color.color}-${color.colorCode}`}
              sx={{
                ...styles(theme).colorSelector,
                border:
                  color.color === selected.color
                    ? `2px solid ${theme.palette.primary.textColor3}`
                    : 'none',
              }}
              onClick={() => handleColorChange(color.color)}
            >
              <Button
                sx={{
                  ...styles(theme).colorSelectorChange,
                  backgroundColor:
                    color.color === theme.palette.primary.contrastText
                      ? theme.palette.secondary.handsetColorBackground
                      : color.colorCode,
                  mb: 1,
                  '&:hover': {
                    border: `1px solid ${theme.palette.secondary.activeSlide}`,
                    backgroundColor:
                      color.color === theme.palette.primary.contrastText
                        ? theme.palette.secondary.handsetColorBackground
                        : color.colorCode,
                  },

                  '&:focus-visible': {
                    outlineOffset: i === 0 ? '5px !important' : '3px !important',
                    borderRadius: '20px !important',
                  },
                }}
                onBlur={e => {
                  e.currentTarget.style.borderRadius = '';
                }}
                aria-label="Select 'insert handset colour"
                aria-pressed={color.color === selectedColor}
              />
            </Box>
          </Stack>
        ))}
      </Stack>
    </Stack>
  ) : (
    <Stack>
      <Skeleton variant='text' width='30%' sx={{ mb: 1 }} />
      <Stack direction='row'>
        {Array(3)
          .fill()
          .map((_, i) => (
            <Box key={i} sx={{ flex: 0.2, mr: 2 }}>
              <Skeleton variant='rectangular' width={25} height={25} sx={{ m: '0 auto' }} />
              <Skeleton />
            </Box>
          ))}
      </Stack>
    </Stack>
  );
};

export default HandsetColorSelector;
